import { AnalysisSteps } from "@dune/types";
import { HorizontalStepper } from "@dune/ui";
import { useQueryState } from "nuqs";
import { useNavigate } from "react-router-dom";
import { useGetConstructionSiteDetails } from "../../../api/queries/constructionSite.queries";
import { useGetConstructionSiteDerogations } from "../../../api/queries/constructionSiteSubmission.queries";
import { useRequiredParams } from "../../../hooks/useRequiredParams";
import { useGetConstructionSiteAnalysisData } from "./hooks/useConstructionSiteAnalysisData";
import { ControlsStep } from "./steps/ControlsStep";
import { DerogationStep } from "./steps/DerogationStep";
import { ValidationStep } from "./steps/ValidationStep";

const ANALYSIS_STEP_CONTROLS = AnalysisSteps.CONTROLS;
const ANALYSIS_STEP_DEROGATION = AnalysisSteps.DEROGATION;
const ANALYSIS_STEP_VALIDATION = AnalysisSteps.VALIDATION;

const ANALYSIS_STEPS = [
	{
		step: ANALYSIS_STEP_CONTROLS,
		title: "Contrôles",
	},
	{
		step: ANALYSIS_STEP_DEROGATION,
		title: "Dérogation",
	},
	{
		step: ANALYSIS_STEP_VALIDATION,
		title: "Validation",
	},
];

export const ConstructionSiteAnalysisContent = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();

	// Preload queries in parallel so step UIs don't load sequentially
	useGetConstructionSiteDetails(constructionSiteId);
	useGetConstructionSiteDerogations(Number(constructionSiteId));
	useGetConstructionSiteAnalysisData(Number(constructionSiteId));

	const handleClose = () => navigate(-1);

	const [currentStepIndex, setCurrentStepIndex] = useQueryState("step", {
		defaultValue: ANALYSIS_STEP_CONTROLS,
		parse: (value) => {
			const parsed = Number(value);
			if (Number.isNaN(parsed) || parsed < 1 || parsed > 3) {
				return ANALYSIS_STEP_CONTROLS;
			}
			return parsed;
		},
		serialize: (value) => String(value),
	});

	return (
		<div className="flex flex-col gap-4">
			<HorizontalStepper
				steps={ANALYSIS_STEPS}
				currentStepIndex={currentStepIndex}
				setCurrentStepIndex={setCurrentStepIndex}
				disableFreeNavigation
				parentPaddingOffsetPx={24}
			/>
			{currentStepIndex === ANALYSIS_STEP_CONTROLS && (
				<ControlsStep
					handleNextStep={() => setCurrentStepIndex(ANALYSIS_STEP_DEROGATION)}
					handleClose={handleClose}
				/>
			)}
			{currentStepIndex === ANALYSIS_STEP_DEROGATION && (
				<DerogationStep
					handlePreviousStep={() => setCurrentStepIndex(ANALYSIS_STEP_CONTROLS)}
					handleNextStep={() => setCurrentStepIndex(ANALYSIS_STEP_VALIDATION)}
					handleClose={handleClose}
				/>
			)}
			{currentStepIndex === ANALYSIS_STEP_VALIDATION && (
				<ValidationStep
					handlePreviousStep={() =>
						setCurrentStepIndex(ANALYSIS_STEP_DEROGATION)
					}
				/>
			)}
		</div>
	);
};
